import {SwitchControl, SwitchRoot} from '../components'
import {Switch as ArkSwitch} from '@ark-ui/react/switch'

/**
 * @typedef {Object} SwitchInputProps
 * @property {boolean} [value] Controlled checked state.
 * @property {(value: boolean) => void} [onChange] Called with the next checked state.
 * @property {boolean} [disabled] Prevents interaction with the switch.
 * @property {boolean} [readOnly] Prevents value changes while retaining focus behavior.
 * @property {import('react').KeyboardEventHandler<HTMLInputElement>} [onKeyDown]
 */

/** @param {SwitchInputProps} props */
export const Switch = ({value, onChange, disabled, readOnly, onKeyDown}) => {
	return (
		<SwitchRoot value={value} onChange={onChange} disabled={disabled} readOnly={readOnly} className="switch">
			<ArkSwitch.HiddenInput onKeyDown={onKeyDown} />
			<SwitchControl />
		</SwitchRoot>
	)
}
